export default __webpack_public_path__ + "static/media/infographic-arrow-left.3cbdcc96.svg";